module.exports = __webpack_public_path__ + "img/bank_02.0c0af247.png";